import { gql } from '@apollo/client';

const REGION_QUERY = gql`
  query getRegion($regionId: String!) {
    region(regionId: $regionId) {
      rentalscapeConfig {
        name
        emailCcDeckard
        showOwnerOccupied
        propertySummaryMode
        propertyDetails {
          tabs {
            license {
              enabled
              upgradeRequired
            }
            history {
              enabled
              upgradeRequired
            }
            activity {
              enabled
              upgradeRequired
            }
            tot {
              enabled
            }
            inspections {
              enabled
            }
          }
        }
        expressSTRTaxModule {
          tax_config {
            key
            label
            infoText
            breakdown {
              key
              label
              infoText
            }
          }
        }
        strTaxModule {
          tax_config {
            key
            label
            infoText
            breakdown {
              key
              label
              infoText
            }
          }
        }
      }
    }
  }
`;

export default REGION_QUERY;
